export enum Awards {
  Gold2024 = 1,
  Silver2024,
}

export enum GameType {
  SolitaireClash = 'solitaire-clash',
  BingoClash = 'bingo-clash',
  BingoTour = 'bingo-tour',
  EightBallStrike = '8-ball-strike',
  SolitaireVenture = 'solitaire-venture',
  Pocket7Games = 'pocket7games',
  Blockolot = 'blockolot',
  BubbleBuzz = 'bubble-buzz',
  CashPool = 'cash-pool',
  SolitaireInfinite = 'solitaire-infinite',
  SolitaireSlam = 'solitaire-slam',
  BingoBliss = 'bingo-bliss',
  MatchNFlip = 'match-n-flip',
  PlaySolitaireOnline = 'playsolitaireonline',
  TwentyOneGold = '21-gold',
  TileBlitz = 'tile-blitz',
  NumbersBlitz = '2048-blitz',
  PoolClash = 'pool-clash',
  DunkShot = 'dunk-shot',
  Dominoes = 'dominoes',
}

export const GamesNames: Record<GameType, string> = {
  [GameType.SolitaireClash]: 'Solitaire Clash',
  [GameType.BingoClash]: 'Bingo Clash',
  [GameType.BingoTour]: 'Bingo Tour',
  [GameType.EightBallStrike]: '8 Ball Strike',
  [GameType.SolitaireVenture]: 'Solitaire Venture',
  [GameType.Pocket7Games]: 'Pocket7Games',
  [GameType.Blockolot]: 'Blockolot',
  [GameType.BubbleBuzz]: 'Bubble Buzz',
  [GameType.CashPool]: 'Cash Pool',
  [GameType.SolitaireInfinite]: 'Solitaire Infinite',
  [GameType.SolitaireSlam]: 'Solitaire Slam',
  [GameType.BingoBliss]: 'Bingo Bliss',
  [GameType.MatchNFlip]: "Match 'n Flip",
  [GameType.PlaySolitaireOnline]: 'Solitaire!',
  [GameType.TwentyOneGold]: '21 Gold',
  [GameType.TileBlitz]: 'Tile Blitz',
  [GameType.NumbersBlitz]: '2048 Blitz',
  [GameType.PoolClash]: 'Pool Clash',
  [GameType.DunkShot]: 'Dunk Shot',
  [GameType.Dominoes]: 'Dominoes',
}

const pocket7GamesRatings = {
  score: 4.5,
  ratings: '102K',
}

export const GameRatings: Record<
  GameType,
  {
    score: number
    ratings: string
  }
> = {
  [GameType.SolitaireClash]: { score: 4.8, ratings: '330.7K' },
  [GameType.BingoClash]: { score: 4.5, ratings: '122.8K' },
  [GameType.BingoTour]: { score: 4.8, ratings: '207.7K' },
  [GameType.EightBallStrike]: { score: 4.8, ratings: '46.8K' },
  [GameType.SolitaireVenture]: { score: 4.8, ratings: '17.5K' },
  [GameType.Pocket7Games]: pocket7GamesRatings,
  [GameType.Blockolot]: { score: 4.8, ratings: '17.1K' },
  [GameType.BubbleBuzz]: { score: 4.8, ratings: '65.2K' },
  [GameType.CashPool]: { score: 4.8, ratings: '4.4K' },
  [GameType.SolitaireInfinite]: { score: 4.9, ratings: '11.5K' },
  [GameType.SolitaireSlam]: { score: 4.9, ratings: '10.6K' },
  [GameType.BingoBliss]: { score: 4.9, ratings: '8.4K' },
  [GameType.MatchNFlip]: pocket7GamesRatings,
  [GameType.PlaySolitaireOnline]: pocket7GamesRatings,
  [GameType.TwentyOneGold]: pocket7GamesRatings,
  [GameType.TileBlitz]: pocket7GamesRatings,
  [GameType.NumbersBlitz]: pocket7GamesRatings,
  [GameType.PoolClash]: pocket7GamesRatings,
  [GameType.DunkShot]: pocket7GamesRatings,
  [GameType.Dominoes]: pocket7GamesRatings,
}
